import React, { Component } from 'react'

export default class ToastMsg extends Component {

    componentDidMount(){
        let {remove, id} = this.props;
        setTimeout(() => {
            remove(id);
        }, 3000);
    }

    render() {
        return (
            <div className={`toast slideInRight toast-${this.props.success ? "success": "error"}`}>
                <p>{this.props.text}</p>
            </div>
        )
    }
}
